import { useTranslation } from 'react-i18next';
import type { TourDefinition } from '@klonup/design-system';

export function useBackupManagerWelcomeTour(): TourDefinition {
  const { t } = useTranslation();
  return {
    id: 'bm-welcome',
    title: t('onboarding.bm_welcome.menuTitle'),
    description: t('onboarding.bm_welcome.menuDescription'),
    icon: '👋',
    // Las anclas del tour (org-*) solo existen en MyOrganizationPage. Si el BM lo lanza
    // desde otra ruta, OrgLayout navega aquí antes de arrancar (igual que welcomeAdmin).
    requiredPath: 'my-organization',
    steps: [
      {
        id: 'welcome',
        // Sin target → se renderiza como modal centrado de bienvenida.
        title: t('onboarding.bm_welcome.steps.welcome.title'),
        description: t('onboarding.bm_welcome.steps.welcome.description'),
      },
      {
        id: 'overview',
        target: '[data-tour="org-overview"]',
        title: t('onboarding.bm_welcome.steps.overview.title'),
        description: t('onboarding.bm_welcome.steps.overview.description'),
      },
      {
        id: 'connections',
        target: '[data-tour="org-connections"]',
        title: t('onboarding.bm_welcome.steps.connections.title'),
        description: t('onboarding.bm_welcome.steps.connections.description'),
      },
      {
        id: 'users',
        target: '[data-tour="org-users"]',
        title: t('onboarding.bm_welcome.steps.users.title'),
        description: t('onboarding.bm_welcome.steps.users.description'),
      },
      {
        id: 'help',
        target: '[data-tour="open-tutorials"]',
        title: t('onboarding.bm_welcome.steps.help.title'),
        description: t('onboarding.bm_welcome.steps.help.description'),
      },
    ],
  };
}
